type PasswordValidationResult = boolean[];

export const PASSWORD_REQUIREMENTS = {
  MIN_LENGTH: 8,
  MAX_LENGTH: 20,
  MIN_LOWERCASE: 2,
  SPECIAL_CHARS: "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~@"
} as const;

export const PASSWORD_PATTERNS = {
  UPPERCASE: /[A-Z]/, // At least one uppercase letter
  LOWERCASE: /[a-z].*[a-z]/, // At least two lowercase letters
  NUMBER: /[0-9]/, // At least one number
  SPECIAL_CHAR: new RegExp(`[${PASSWORD_REQUIREMENTS.SPECIAL_CHARS}]`) // At least one special character
} as const;

export const isValidatePassword = (value: string): PasswordValidationResult => {
  return [
    value.length >= PASSWORD_REQUIREMENTS.MIN_LENGTH &&
      value.length <= PASSWORD_REQUIREMENTS.MAX_LENGTH,
    PASSWORD_PATTERNS.UPPERCASE.test(value),
    PASSWORD_PATTERNS.LOWERCASE.test(value),
    PASSWORD_PATTERNS.NUMBER.test(value),
    PASSWORD_PATTERNS.SPECIAL_CHAR.test(value)
  ];
};
